// extracted by mini-css-extract-plugin
export default {"instancesInformation":"Instances_instancesInformation__Pkacv","noOptions":"Instances_noOptions__vd7g3"};